/* unplugin-vue-components disabled */import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState } from 'vuex';
import getWaterMarkCanvas from '@/libs/water-mark';
export default {
  name: 'i-water-mark',
  computed: _objectSpread(_objectSpread({}, mapState('admin/layout', ['waterMark'])), {}, {
    styles: function styles() {
      var url = getWaterMarkCanvas(this.waterMark.text, this.waterMark.options);
      return {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        'z-index': '2000',
        'background-size': '320px',
        'background-repeat': 'repeat',
        'background-image': "url(".concat(url, ")"),
        'pointer-events': 'none'
      };
    }
  })
};